import { Skeleton, styled } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { FC } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { AssistantShortDTO } from '../../../../api/gen/base'
import AssistantCard from '../../AssistantShopPage/AssistantCard'

const AssistantCardsWrapper = styled(Grid)<{ cols?: number }>(({ theme, cols }) => ({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: `repeat(${cols ?? 3}, 1fr)`,
    columnGap: '16px',
    rowGap: '16px',
    [theme.breakpoints.down('xl')]: {
        gridTemplateColumns:  '1fr 1fr',
    },
    [theme.breakpoints.down('lg')]: {
        gridTemplateColumns:  '1fr',
    },
}))


interface Props {
    cols?: number
    onClickCard?: (assistantId: string) => void
    list?: AssistantShortDTO[]
    loading: boolean
    hasNextPage: boolean
    onLoadMore: () => Promise<void>
}

export const AssistantList: FC<Props> = ({
    cols,
    onClickCard,
    list = [],
    loading,
    hasNextPage,
    onLoadMore,
}) => {
    const [infiniteRef] = useInfiniteScroll({
        loading,
        hasNextPage,
        onLoadMore,
    })

    return (
        <AssistantCardsWrapper cols={cols}>
            {list.map((item, index) => {

                return (
                    <AssistantCard
                        key={item.id}
                        onClickCard={onClickCard}
                        assistant={item}
                    />
                )
            })}
            {hasNextPage && (
                <Skeleton
                    ref={infiniteRef}
                    variant="rectangular"
                    sx={{
                        borderRadius: '22px',
                        height: '250px',
                        maxHeight: '260px',
                    }}
                />
            )}
        </AssistantCardsWrapper>
    )
}
